import { render, staticRenderFns } from "./EditMessage.vue?vue&type=template&id=81e09454"
import script from "./EditMessage.vue?vue&type=script&lang=js"
export * from "./EditMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports